import React from "react";

const RemoveButton = ({onClick}) => {
    return <div style={{color: "#E85E5E", cursor: "pointer"}}
                onClick={onClick}>ⓧ</div>;
}


export default RemoveButton;